<template>
  <v-col
    v-if="isObjectCreated"
    align-self="center"
    cols="auto"
  >
    <v-text-field
      v-model="currentX"
      class="d-inline-flex mx-2"
      :style="'width: ' + fieldWidth"
      hide-details="auto"
      suffix="px"
      solo
      dense
      :disabled="!isMovable"
      @blur="onFocus(false)"
      @focus="onFocus(true)"
    >
      <template v-slot:prepend> {{ $t("creation.toolbar.posx") }}: </template>
    </v-text-field>

    <v-text-field
      v-model="currentY"
      class="d-inline-flex mr-4"
      :style="'width: ' + fieldWidth"
      hide-details="auto"
      suffix="px"
      solo
      dense
      :disabled="!isMovable"
      @blur="onFocus(false)"
      @focus="onFocus(true)"
    >
      <template v-slot:prepend> {{ $t("creation.toolbar.posy") }}: </template>
    </v-text-field>

    <v-text-field
      v-model="currentScaleX"
      class="d-inline-flex mr-2"
      :style="'width: ' + fieldWidth"
      hide-details="auto"
      suffix="%"
      solo
      dense
      :disabled="!isMovable"
      @blur="onFocus(false)"
      @focus="onFocus(true)"
    >
      <template v-slot:prepend> {{ $t("creation.toolbar.width") }}: </template>
    </v-text-field>

    <v-text-field
      v-model="currentScaleY"
      class="d-inline-flex mr-2"
      :style="'width: ' + fieldWidth"
      hide-details="auto"
      suffix="%"
      solo
      dense
      :disabled="!isMovable"
      @blur="onFocus(false)"
      @focus="onFocus(true)"
    >
      <template v-slot:prepend> {{ $t("creation.toolbar.height") }}: </template>
    </v-text-field>
  </v-col>
</template>

<script>
function checkValueInt(value, defaultValue) {
  const parsed = parseInt(value, 10);
  if (isNaN(parsed)) {
    return defaultValue;
  }
  return parsed;
}

function checkValueFloat(value) {
  const parsed = parseFloat(value);
  if (isNaN(parsed)) {
    return 0.01;
  }
  return parsed;
}

export default {
  props: {
    objectCreated: {
      type: Object,
      default: () => {},
    },
    currentTransformer: {
      type: Object,
      default: () => {},
    },
    creationController: {
      type: Object,
      default: () => {},
    },
    isObjectCreated: {
      type: Boolean,
      default: false,
    },
    partial: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fieldWidth: "105px",
    };
  },
  computed: {
    currentX: {
      get() {
        if (this.objectCreated !== undefined) {
          return checkValueInt(this.objectCreated.x, 0).toFixed(0);
        } else {
          return 0;
        }
      },
      set(value) {
        this.objectCreated.x = checkValueInt(value, 0).toFixed(0);
      },
    },
    currentY: {
      get() {
        if (this.objectCreated !== undefined) {
          return checkValueInt(this.objectCreated.y, 0).toFixed(0);
        } else {
          return 0;
        }
      },
      set(value) {
        this.objectCreated.y = checkValueInt(value, 0).toFixed(0);
      },
    },
    currentWidth: {
      get() {
        if (this.objectCreated !== undefined) {
          return checkValueInt(this.objectCreated.width, 1).toFixed(0);
        } else {
          return 1;
        }
      },
      set(value) {
        this.objectCreated.width = checkValueInt(value, 1);
      },
    },
    currentHeight: {
      get() {
        if (this.objectCreated !== undefined) {
          return checkValueInt(this.objectCreated.height, 1).toFixed(0);
        } else {
          return 1;
        }
      },
      set(value) {
        this.objectCreated.height = checkValueInt(value, 1);
      },
    },
    currentScaleX: {
      get() {
        if (this.objectCreated !== undefined) {
          return checkValueFloat(this.objectCreated.scaleX).toFixed(2);
        } else {
          return 0.01;
        }
      },
      set(value) {
        this.objectCreated.scaleX = checkValueFloat(value).toFixed(2);
      },
    },
    currentScaleY: {
      get() {
        if (this.objectCreated !== undefined) {
          return checkValueFloat(this.objectCreated.scaleY).toFixed(2);
        } else {
          return 0.01;
        }
      },
      set(value) {
        this.objectCreated.scaleY = checkValueFloat(value).toFixed(2);
      },
    },
    isMovable() {
      // Check movable to authorize resize
      let isMovable = false;
      if (this.objectCreated !== undefined) {
        if (this.objectCreated.movable !== undefined) {
          if (this.objectCreated.movable) {
            isMovable = true;
          }
        } else {
          isMovable = true;
        }
      } else {
        isMovable = true;
      }

      return isMovable;
    },
  },
  methods: {
    onFocus(isFocused) {
      this.$emit("onFocus", isFocused);
    },
  },
};
</script>

<style>
.theme--dark label {
  color: white;
}

.v-text-field.v-text-field--solo.v-input--dense .v-input__prepend-outer,
.v-text-field.v-text-field--solo.v-input--dense .v-input__append-outer {
  margin-top: 11px;
}
</style>
